import { BASE_URL } from "./axios";

// Deliberately separate from the main app's authStore/useAuth — this
// token only works on /seasons/* allocation endpoints and is stored under
// its own localStorage key so it's fully independent of whether someone
// is logged into the main Chicago News site.
const STORAGE_KEY = "allocation_session_token";
const EMAIL_KEY = "allocation_session_email";

export function getAllocationToken() {
  return localStorage.getItem(STORAGE_KEY);
}

export function getAllocationEmail() {
  return localStorage.getItem(EMAIL_KEY);
}

export function setAllocationSession(token, email) {
  localStorage.setItem(STORAGE_KEY, token);
  localStorage.setItem(EMAIL_KEY, email);
}

export function clearAllocationSession() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(EMAIL_KEY);
}

async function allocationFetch(path, options = {}) {
  const token = getAllocationToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  let body = null;
  try { body = await res.json(); } catch { /* no body */ }

  if (!res.ok) {
    const message = Array.isArray(body?.message) ? body.message.join(", ") : (body?.message ?? "Something went wrong");
    if (res.status === 401) clearAllocationSession();
    throw new Error(message);
  }
  return body?.data ?? body;
}

export const requestAllocationCode = (email) =>
  allocationFetch("/allocation-auth/request-code", {
    method: "POST",
    body: JSON.stringify({ email }),
  });

export const verifyAllocationCode = async (challengeId, email, code) => {
  const result = await allocationFetch("/allocation-auth/verify-code", {
    method: "POST",
    body: JSON.stringify({ challengeId, email, code }),
  });
  setAllocationSession(result.token, result.email);
  return result;
};

export { allocationFetch };
